import { useState, useEffect } from 'react';
import { ajax } from 'jquery';
import './index.css';

function replaceSpacesWithUnderscoresUsingReplaceAll(str: string): string {
    return str.replaceAll(' ', '_');
}
interface Country {
    id: number;
    name: string;
    hash: string;
    name_en: string;
}

interface User {
    id: number;
    username: string;
    avatarCountry?: Country;
    avatarExpressionType?: number;
    avatarExpressionOrientation?: number;
    activedCountries: Country[];
}

function deleteCookie(name: string) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function clearAllCookies() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        deleteCookie(name.trim());
    }
}

export default function Setting() {
    const [user, setUser] = useState<User | null>(null);
    const [countries, setCountries] = useState<Country[]>([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [showAvatarModal, setShowAvatarModal] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);
    const [selectedBall, setSelectedBall] = useState<any>()
    const [selectedFace, setSelectedFace] = useState<number>(0)
    const [selectedDirection, setSelectedDirection] = useState<string>("")
    const [avatarData, setAvatarData] = useState<any>()

    // 新增状态
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(12); // 每页显示12个国家

    const [showPasswordModal, setShowPasswordModal] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            try {
                const [userResult] = await Promise.all([
                    ajax({
                        method: "GET",
                        url: '/api/v1/countryball_card/user',
                    })
                ]);

                setUser(userResult);
                setCountries(userResult.activedCountries);
                setSelectedBall(userResult.avatarCountry.name_en)
                setSelectedFace(userResult.avatarExpressionType)
                setSelectedDirection(userResult.avatarExpressionOrientation)
                setLoading(false);
            } catch (err) {
                console.error('Failed to load data:', err);
                setLoading(false);
            }
        };

        loadData();
    }, []);
    const faceArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]

    // 过滤和分页逻辑
    const filteredCountries = countries.filter(country =>
        country.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredCountries.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentCountries = filteredCountries.slice(startIndex, endIndex);

    // 处理搜索
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // 重置到第一页
    };


    const logout = () => {
        clearAllCookies();
        window.location.href = '/login';
    }

    const handlePasswordChange = async (e: React.FormEvent) => {
        e.preventDefault();
        const form = e.target as HTMLFormElement;
        const formData = new FormData(form);
        const oldPassword = formData.get('oldPassword') as string;
        const newPassword = formData.get('newPassword') as string;
        const confirmPassword = formData.get('confirmPassword') as string;

        if (newPassword !== confirmPassword) {
            alert('新密码和确认密码不一致');
            return;
        }

        try {
            await ajax({
                method: "POST",
                url: '/api/v1/countryball_card/user/password',
                data: {
                    oldPassword,
                    newPassword
                }
            });
            alert('密码修改成功');
            form.reset();
        } catch (err: any) {
            alert(err.responseJSON?.message || '密码修改失败');
        }
    };

    const handleAvatarSelect = (country: Country) => {
        setSelectedCountry(country);
        setShowAvatarModal(true);
    };

    const handleAvatarSave = async () => {
        if (!selectedBall) return;
        try {
            const result = await ajax({
                method: "POST",
                url: '/api/v1/countryball_card/user/update',
                data: {
                    avatarCountry: selectedBall,
                    avatarExpressionType: selectedFace,
                    avatarExpressionOrientation: selectedDirection
                }
            });
            setUser(result);
            setShowAvatarModal(false);
            alert('头像更新成功');
        } catch (err: any) {
            alert(err.responseJSON?.message || '头像更新失败');
        }
    };

    const cancelAvatar = () => {
        setShowAvatarModal(false);
    }


    if (loading) {
        return <div className="loading">加载中...</div>;
    }

    return (
        <div className="setting-page">
            <div className="setting-container">
                <h2 className="setting-title">个人设置</h2>

                {/* 用户信息区域 */}
                <div className="user-info-section">
                    <div className="user-avatar-area">
                        {user?.avatarCountry ? (
                            <div className="avatar-container ball-wrap">
                                <img
                                    className="ball-pic"
                                    src={`https://oss.usecubes.cn/countryballs/new_balls/${user.avatarCountry.name_en.replace(/\s+/g, '_')}.png`}
                                    alt={user.avatarCountry.name}
                                />
                                <img
                                    className="face-pic"
                                    src={'https://oss.usecubes.cn/countryballs/faces/' + (selectedFace + 1 + selectedDirection) + '.png'}
                                    alt="face"
                                />
                            </div>
                        ) : (
                            <div className="avatar-placeholder">未设置头像</div>
                        )}
                        <div className="user-info">
                            <span className="username">{user?.username}</span>
                            <button className="edit-avatar-btn" onClick={() => setShowAvatarModal(true)}>
                                修改头像
                            </button>
                            <button className="edit-password-btn" onClick={() => setShowPasswordModal(true)}>
                                修改密码
                            </button>
                        </div>
                    </div>
                </div>

                {message && <div className="message">{message}</div>}
                
                {/* 退出登录按钮 */}
                <div className="logout-section">
                    <button className="logout-btn-large" onClick={logout}>
                        退出登录
                    </button>
                </div>
            </div>

            {/* 修改密码模态框 */}
            {showPasswordModal && (
                <div className="modal-overlay">
                    <div className="modal-content password-modal">
                        <h3>修改密码</h3>
                        <form onSubmit={handlePasswordChange} className="password-form">
                            <div className="form-group">
                                <label>当前密码</label>
                                <input type="password" name="oldPassword" required />
                            </div>
                            <div className="form-group">
                                <label>新密码</label>
                                <input type="password" name="newPassword" required />
                            </div>
                            <div className="form-group">
                                <label>确认新密码</label>
                                <input type="password" name="confirmPassword" required />
                            </div>
                            <div className="modal-actions">
                                <button type="button" onClick={() => setShowPasswordModal(false)}>取消</button>
                                <button type="submit">确认修改</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* 头像选择模态框 */}
            {showAvatarModal && (
                <div className="select-ball-avatar-wrap">
                    <div className="select-ball-avatar-content">
                        <div className="result-area">
                            {
                                selectedBall && <div className='result-ball-box ball-wrap'>
                                    <img className='ball-pic' src={'https://oss.usecubes.cn/countryballs/balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(selectedBall) + '.png'} alt={selectedBall} />
                                    <img className='face-pic' src={'https://oss.usecubes.cn/countryballs/faces/' + (selectedFace + 1 + selectedDirection) + '.png'} />
                                </div>
                            }
                        </div>
                        <span className="select-notice">请选择国家球（<a href="/myballs" className="go-to-myballs">扫码添加更多国家</a>）</span>
                        <div className="select-ball-area">
                            {
                                user && user.activedCountries.map((country: any, index: number) => {
                                    return <div className={'ball-wrap ' + (selectedBall === country.name_en ? "selected" : "")} key={index} onClick={() => setSelectedBall(country.name_en)}>
                                        <img className='ball-pic' src={'https://oss.usecubes.cn/countryballs/balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(country.name_en) + '.png'} alt={country.name_en} />
                                        <span className="ball-name">{country.name}</span>
                                    </div>
                                })
                            }
                        </div>
                        <span className="select-notice">请选择表情</span>
                        <div className="select-face-area">
                            {
                                faceArr.map((faceName, index) => {
                                    return <div className={'face-wrap ' + (selectedFace === index ? "selected" : "")} key={index} onClick={() => setSelectedFace(index)}>
                                        <img className='face-pic' src={'https://oss.usecubes.cn/countryballs/faces/' + faceName + '.png'} />
                                    </div>
                                })
                            }
                        </div>
                        <span className="select-notice">请选择表情方向</span>
                        <div className="select-direction-area">
                            <a href="#" className={"common-small-btn " + (selectedDirection === "_l" ? "selected" : "")} onClick={(e) => setSelectedDirection("_l")}>向左看</a>
                            <a href="#" className={"common-small-btn " + (selectedDirection === "" ? "selected" : "")} onClick={(e) => setSelectedDirection("")}>向前看</a>
                            <a href="#" className={"common-small-btn " + (selectedDirection === "_r" ? "selected" : "")} onClick={(e) => setSelectedDirection("_r")}>向右看</a>
                        </div>
                        <div className="selecte-ball-btn-box">
                            <a href="#" className="common-small-btn" onClick={cancelAvatar}>取消</a>
                            <a href="#" className="common-small-btn" onClick={handleAvatarSave}>保存</a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
} 